export const CONTACT = {
  phone: "0413 210 077",
  phoneHref: "tel:0413210077",
  email: "s.play.lab.co@gmail.com",
  website: "splaylab.org",
  websiteHref: "https://splaylab.org",
};

export const MELBOURNE_BADGES = [
  "Victorian WWCC Verified",
  "Fully Insured",
  "First Aid Certified",
  "VEYLDF Aligned",
];

export const GUARANTEES = [
  { title: "Custom-tailored sessions", desc: "Shaped around your group, space and goals.", icon: "sparkles" },
  { title: "Zero lock-in", desc: "Nothing is confirmed until you're ready.", icon: "unlock" },
  { title: "Victorian WWCC & insured", desc: "WWCC-checked, first-aid trained, fully insured coaches.", icon: "shield-check" },
  { title: "4-hour response", desc: "Send an inquiry and we reply within 4 business hours.", icon: "clock" },
];

export const AUDIENCES = [
  {
    id: "parents",
    label: "For Parents",
    headline: "Confident, capable kids who love to move",
    blurb: "Flexible sessions any day, any time across Melbourne — building real physical confidence safely, with milestones you can see.",
    points: ["Sessions anytime — weekdays & weekends", "Visible confidence & milestones", "Safety-first WWCC coaches", "Progress you can track"],
    cta: "Request a Custom Quote",
  },
  {
    id: "directors",
    label: "For Directors & Teachers",
    headline: "VEYLDF-aligned programs for your centre",
    blurb: "Curriculum-aligned sessions delivered by our coaches with all equipment supplied — start with a risk-free trial.",
    points: ["EYLF & Victorian Curriculum aligned", "Zero equipment needed from staff", "Risk-free trial, zero lock-in", "Fast 4-hour response"],
    cta: "Book a Risk-Free Trial",
  },
  {
    id: "kids",
    label: "For Students & Kids",
    headline: "Game on! Fun that secretly builds skills",
    blurb: "Obstacle courses, relay races and real sports games — plus coaching badges to earn and loads of high-fives.",
    points: ["Obstacle courses & relays", "Real sports games", "Earn coaching badges", "Loads of smiles"],
    cta: "Explore Sports Programs",
  },
  {
    id: "community",
    label: "For Community / Venues",
    headline: "Pop-ups, holiday programs & venue events",
    blurb: "High-energy movement for your venue or community — holiday camps, pop-ups and flexible group sizes.",
    points: ["Holiday programs & camps", "Pop-up venue events", "Community sports days", "Flexible group sizes"],
    cta: "Plan a Community Event",
  },
];

const IMG = "https://static.prod-images.emergentagent.com/jobs/b13d9c71-eafa-415a-94f2-796d90aec4b3/images";

export const SPORTS = [
  {
    slug: "soccer",
    name: "Soccer",
    image: `${IMG}/15827b2dfcde9237f887f658bdb54124193df2737b8c775914c45866e237d5c1.jpeg`,
    accent: "#0E9E96",
    tagline: "Foot-eye coordination through play",
    intro: "Kids master foot-eye coordination through story-driven games that feel like pure fun.",
    whatWeTeach: ["Dribbling control", "Passing gates", "Foot-eye balance"],
    howWeTeach: ["Story games like 'Protect the Treasure'", "'Laser-Gate Passing' drills"],
    skills: ["Lower-body agility", "Bilateral coordination", "Teamwork"],
  },
  {
    slug: "cricket",
    name: "Cricket",
    image: `${IMG}/378bdc5af5a92e152c67ef07b77f627ecab5711d819bb22a12425cb75b4c1c57.jpeg`,
    accent: "#F97316",
    tagline: "Hand-eye tracking & striking focus",
    intro: "Big lightweight bats and soft foam balls make batting and catching a joy for little players.",
    whatWeTeach: ["Batting stance", "Hand-eye coordination", "Catching & target bowling"],
    howWeTeach: ["Big-headed lightweight bats & foam balls", "'Hit & Run Cone Dash' games"],
    skills: ["Spatial tracking", "Striking focus", "Upper-body control"],
  },
  {
    slug: "basketball",
    name: "Basketball",
    image: `${IMG}/fa7062cf3e9a5767f7da9a27d3541460f933c875e28a3029157917a0684b50bb.jpeg`,
    accent: "#2563EB",
    tagline: "Rhythm, reaction & ball control",
    intro: "Low rims and soft mini-balls build confident ball-handling right from the first bounce.",
    whatWeTeach: ["Two-handed dribbling", "Chest & bounce passing", "Target shooting"],
    howWeTeach: ["Low-rim targets & soft mini-balls", "Rhythm bounce & reaction games"],
    skills: ["Upper-body control", "Fine motor reflexes", "Rhythm & focus"],
  },
  {
    slug: "tennis",
    name: "Tennis",
    image: `${IMG}/0b3c0be2a81f1923b8c1122f4c61f296b0309eebc69869d5b5068ab051c46631.jpeg`,
    accent: "#EAB308",
    tagline: "Timing, footwork & focus",
    intro: "Foam balls and mini racquets turn rallying into an achievable, giggle-filled challenge.",
    whatWeTeach: ["Racquet control", "Rallying & ball tracking", "Ready-position footwork"],
    howWeTeach: ["Foam balls & junior racquets", "'Beat the Bounce' rally games"],
    skills: ["Hand-eye timing", "Agility & footwork", "Patience & focus"],
  },
  {
    slug: "afl",
    name: "AFL Footy",
    image: `${IMG}/2487bc29c4e984c80bf0f9fb2e4f6be89736265593a94e1b9712fdcc2efd68a7.jpeg`,
    accent: "#DC2626",
    tagline: "Kick, handball & mark — Melbourne style",
    intro: "Soft oval balls make kicking, handballing and marking safe and fun for every little Aussie.",
    whatWeTeach: ["Handballing", "Kicking technique", "Marking (catching)"],
    howWeTeach: ["Soft oversized oval balls", "'Mark of the Day' target games"],
    skills: ["Hand-eye coordination", "Gross motor power", "Confidence"],
  },
];

export const SESSION_FLOW = [
  { time: "0–5 min", name: "The Neural Ignition", tag: "Warm-up & brain-body prep", icon: "zap",
    desc: "Coordination and imitation games that activate neuroplasticity and prime the brain-body connection." },
  { time: "5–20 min", name: "Skill Lab 1: Agility & Reaction", tag: "Proprioception", icon: "target",
    desc: "Soft-ball games and varied-speed cones that develop the vestibular system and body mapping." },
  { time: "20–35 min", name: "Skill Lab 2: Balance & Cognition", tag: "Vestibular", icon: "scale",
    desc: "Balancing beams and guided obstacle courses that build core strength, focus and attention." },
  { time: "35–45 min", name: "Cooldown & Emotional Regulation", tag: "Reflection", icon: "wind",
    desc: "Deep breathing and reflection to consolidate learning and regulate emotions." },
];

export const AGE_GROUPS = [
  { id: "elc", label: "Early Learning (ELC)", desc: "Ages 3–5" },
  { id: "kinder", label: "Kinder", desc: "Pre-prep" },
  { id: "primary", label: "Primary (Prep–Year 2)", desc: "School groups" },
  { id: "community", label: "Community / Venue", desc: "Events & camps" },
];

export const PROGRAM_TYPES = [
  { id: "trial", label: "Subsidised Trial", desc: "A subsidised first session — no commitment to continue" },
  { id: "term", label: "Ongoing Term Program", desc: "Weekly sessions across a school term" },
  { id: "holiday", label: "Holiday Workshop", desc: "School-holiday camps & pop-up events" },
];
